module.exports = __webpack_public_path__ + "img/fan-blades_106x106.172eec0f.png";